// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8XBgk","name":"Header_name__aEaVy","birthday":"Header_birthday__dDT8w","skeleton":"Header_skeleton__3rkSq"};